var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 2c.547 0 .991.444.991.991v.9a.991.991 0 0 1-1.982 0v-.9c0-.547.444-.991.991-.991M4.903 4.903a.99.99 0 0 1 1.401 0l.54.54a.991.991 0 1 1-1.4 1.402l-.541-.54a.99.99 0 0 1 0-1.402m14.194 0a.99.99 0 0 1 0 1.401l-.54.541a.991.991 0 0 1-1.402-1.402l.541-.54a.99.99 0 0 1 1.401 0M12 7.586a4.414 4.414 0 1 0 0 8.828 4.414 4.414 0 0 0 0-8.828M5.604 12a6.396 6.396 0 1 1 9.189 5.756v1.451a2.793 2.793 0 0 1-5.586 0v-1.45A6.4 6.4 0 0 1 5.604 12m5.585 6.346v.861a.81.81 0 1 0 1.622 0v-.861a6.5 6.5 0 0 1-1.622 0M2 12c0-.547.444-.991.991-.991h.9a.991.991 0 0 1 0 1.982h-.9A.99.99 0 0 1 2 12m17.117 0c0-.547.444-.991.991-.991h.901a.991.991 0 0 1 0 1.982h-.9a.99.99 0 0 1-.992-.991",
    clipRule: "evenodd"
  })));
};
export default SvgLightBulb;